/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useCallback, useEffect, useState } from 'react';

import { SNOWPLOW_EVENTS } from '../../../../../services/analytics/analytics.const';
import { motorwayPayPageEvents } from '../../../../../services/analytics/events/paymentEvents/motorwayPayPageEvents';

export const useVideoModal = (props?: { eventName?: string }) => {
	const [state, setState] = useState<boolean>(false);

	const eventName = props?.eventName ?? 'Payments video modal clicked';

	const closeModal = useCallback(() => {
		motorwayPayPageEvents<{
			label: string;
		}>({
			customData: {
				label: 'closed',
			},
			name: eventName,
			schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
			version: SNOWPLOW_EVENTS.CLICK.VERSION,
		});
		setState(false);
	}, [eventName]);

	const openModal = useCallback(() => {
		motorwayPayPageEvents<{
			label: string;
		}>({
			customData: {
				label: 'opened',
			},
			name: eventName,
			schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
			version: SNOWPLOW_EVENTS.CLICK.VERSION,
		});
		setState(true);
	}, [eventName]);

	useEffect(() => {
		document.body.style.overflow = state ? 'hidden' : '';
	}, [state]);

	return {
		closeModal,
		openModal,
		state,
	};
};
